import Tutorial from 'src/components/Tutorial'
import SimpleLayout from 'src/layouts/SimpleLayout'

const DESCRIPTIONS = [
  'The reading view shows the current page of the book in the target language. To change the page, swipe left or right.\nTo jump to a specific page, tap the page number.',
  'To switch between translations, use the bottom right button.',
  'The original langauge view is a scrollable section that shows the current chapter in your native language.\nUse this view to help you understand the target language view.',
  'To see the definition of a word, tap on a word while in the original language view.',
  "If the word's definition is found, you can add it to your vocab bank by clicking the '+' button.",
  'Words in your vocab bank are highlighted.\nTry to remember the definition when you next see the word in text! Use context clues or your native language view to help.',
  'At any time, view all the words you have added by clicking the vocab button in the bottom left.',
  'You can clear out any words you have added by clicking "Remove".',
]

const ReaderTutorial = () => (
  <SimpleLayout simple>
    <Tutorial
      numPages={DESCRIPTIONS.length}
      tutorialId="reader"
      descriptions={DESCRIPTIONS}
    />
  </SimpleLayout>
)

export default ReaderTutorial
